import { render } from "./Popups.vue?vue&type=template&id=1297df99&scoped=true"
import script from "./Popups.vue?vue&type=script&lang=js"
export * from "./Popups.vue?vue&type=script&lang=js"

import "./Popups.vue?vue&type=style&index=0&id=1297df99&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1297df99"]])

export default __exports__